import React, { memo } from 'react';
import styled, { css } from 'styled-components';

import { SIZES, TYPES, LINK_COLOR, SIZE_CONFIG } from '@front/common/src/constants/link';
import { CommonTextButtonProps, FontWeight } from '@front/common/src/types/components';

import Text, { FONT_WEIGHTS } from '../base-text/base-text';
import { StylelessButton } from '../utils';
import { linkStyle } from '../link/common';

export const disabledStyle = css`
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const StyledButton = styled(StylelessButton)<{ $color: string }>`
  ${({ $color }) => linkStyle($color)}
  ${disabledStyle};
`;

// TODO replace onClick with onPress
export type TextButtonProps = CommonTextButtonProps & {
  label?: string;
  isDisabled?: boolean;
  fontWeight?: FontWeight;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const TextButton = ({
  children,
  isDisabled = false,
  label,
  onClick,
  fontWeight = 500,
  className,
  type = 'normal',
  size = 'md',
}: TextButtonProps) => {
  const textColor = LINK_COLOR[type];
  return (
    <StyledButton
      onClick={onClick}
      disabled={isDisabled}
      aria-label={label}
      type='button'
      className={className}
      $color={textColor}
    >
      <Text color={textColor} {...SIZE_CONFIG[size]} fontWeight={fontWeight}>
        {children}
      </Text>
    </StyledButton>
  );
};

export { SIZES, TYPES, FONT_WEIGHTS };
export default memo(TextButton);
